import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import Vector from "../assets/SVG/vector";
import DashboardGroup from "./dashboardGroup";
import GroupInfo from "./groupInfo";
import HistoryCamp from "./historyCamp";
import Mujahids from "./mujahids";
import TabBar from "./tabBar";

export default function ViewInfo({ titr, setMode,color,name,data,dataAdmin,id,dataGroup }) {
    const [selected, setSelected] = useState(0);
  return (
    <>
      <Box
        marginTop={"40px"}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography className="title_GroupOnline">{titr}</Typography>
        <Box
          sx={{ cursor: "pointer" }}
          onClick={() => setMode("create")}
          display="flex"
          alignItems="center"
        >
          <Vector />
        </Box>
      </Box>
      <TabBar setSelected={setSelected} selected={selected} />
      <Box pl='40px' >

      {selected===0&& <DashboardGroup data={data} /> }
      {selected===1&& <HistoryCamp id={id} /> }
      {selected===2&& <Mujahids dataGroup={dataGroup} /> }
      {selected===3&& <GroupInfo groupId={id} ownerId={dataGroup.owner}  /> }
      </Box>

    </>
  );
}
